(function () {
  function getSearchModal() {
    return document.getElementById('search-modal');
  }

  function focusSearchInput(modal) {
    const input = modal?.querySelector('input[type="search"], input.search-input');
    if (input instanceof HTMLInputElement) {
      input.focus();
      input.select();
    }
  }

  function openSearchModal() {
    const modal = getSearchModal();
    if (!modal) return false;

    if (typeof modal.showDialog === 'function') {
      modal.showDialog();
    } else {
      const dialog = modal.querySelector('dialog');
      if (!(dialog instanceof HTMLDialogElement)) return false;
      if (!dialog.open) dialog.showModal();
    }

    requestAnimationFrame(() => focusSearchInput(modal));
    return true;
  }

  document.addEventListener(
    'click',
    (event) => {
      const openTrigger = event.target.closest('[data-mcp-search-open]');
      if (!openTrigger) return;

      event.preventDefault();
      openSearchModal();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      openSearchModal();
    }
  });

  document.addEventListener('click', (event) => {
    const viewAll = event.target.closest('.predictive-search__search-button');
    if (!viewAll) return;

    const form = viewAll.closest('form');
    const input = form?.querySelector('input[type="search"], input.search-input');
    const query = input?.value?.trim();

    if (!query) return;

    event.preventDefault();
    const searchUrl = new URL(window.Theme?.routes?.search_url || '/search', window.location.origin);
    searchUrl.searchParams.set('q', query);
    window.location.href = searchUrl.toString();
  });
})();
